import type { KeyboardShortcut } from "./keyboardShortcut";

/** The save shortcut of a magic form without `saveShortcut`: ⌘S or Ctrl+S. */
export const DEFAULT_MAGIC_FORM_SAVE_SHORTCUT: KeyboardShortcut = {
  key: "s",
  mod: true,
  shiftKey: false,
  altKey: false,
};

/**
 * The save shortcut in effect for a `saveShortcut` prop: the default when it
 * is not set, `undefined` when it is `false`.
 *
 * @internal Building block of the magic forms, not public API.
 */
export function resolveSaveShortcut(
  saveShortcut: KeyboardShortcut | false | undefined,
): KeyboardShortcut | undefined {
  return saveShortcut === undefined
    ? DEFAULT_MAGIC_FORM_SAVE_SHORTCUT
    : saveShortcut || undefined;
}

/**
 * Finds a save button's element at key time; see
 * `FormContextType.registerShortcutTarget`.
 */
export type MagicFormShortcutTarget = () => HTMLElement | null | undefined;

/**
 * The element of the first registered save button that is in the document.
 *
 * @internal Building block of the magic forms, not public API.
 */
export function findShortcutTarget(
  targets: ReadonlySet<MagicFormShortcutTarget>,
): HTMLElement | undefined {
  for (const getTarget of targets) {
    const element = getTarget();
    if (element?.isConnected) {
      return element;
    }
  }
  return undefined;
}
